import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'

// Registered workflow routes. commissioning-workflows appends
// an entry here when it injects a feature/route, and the card list below renders
// links to each so Home becomes a launcher as workflows are added.
//
const registeredWorkflows: { path: string; label: string; description: string }[] = [
  // { path: '/myflow', label: 'My Workflow', description: 'One-line summary.' },
  { path: '/steward', label: 'steward', description: 'Scaffolded workflow — the node-builder fills the UI.' },
  { path: '/scla', label: 'scla', description: 'Four friends. Seven NBA teams each. One season-long rivalry.' },
  // >>> NEW_WORKFLOW_REGISTRY — commissioning-workflows inserts cards here <<<
]

export function HomePage() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16">
        <div className="flex flex-col items-center text-center">
          <div className="flex items-center justify-center w-12 h-12 rounded-xl border border-border bg-muted">
            <Sparkles className="w-5 h-5 text-muted-foreground" strokeWidth={1.5} />
          </div>

          <h1 className="mt-6 text-2xl font-light tracking-tight text-foreground">
            factory is ready
          </h1>
          <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-muted-foreground">
            This factory spine provides auth, the app shell, streaming transport,
            durable workflow infrastructure, and the registered workflows below.
          </p>

          <div className="mt-8 w-full max-w-md rounded-lg border border-border bg-card p-5 text-left">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Next step
            </p>
            <p className="mt-2 text-sm font-light leading-relaxed text-foreground">
              Scaffold your first workflow with{' '}
              <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[0.8em]">
                commissioning-workflows
              </code>
              . It injects a feature, route, and store into the marked insertion
              points across this baseline.
            </p>
          </div>
        </div>

        {/* Registered workflows — empty until /new-workflow adds the first. */}
        <div className="mt-12">
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            Registered workflows
          </p>

          {registeredWorkflows.length === 0 ? (
            <p className="mt-3 text-sm font-light text-muted-foreground">
              None yet. They'll appear here once you scaffold one.
            </p>
          ) : (
            <ul className="mt-4 space-y-2">
              {registeredWorkflows.map(({ path, label, description }) => (
                <li key={path}>
                  <Link
                    to={path}
                    className="block rounded-md border border-border bg-card px-4 py-3 transition-colors hover:bg-muted"
                  >
                    <span className="text-sm font-medium text-foreground">{label}</span>
                    <span className="mt-0.5 block text-sm font-light text-muted-foreground">
                      {description}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  )
}
